import React from 'react';
import { history } from 'umi';

import styles from '../styles.scss';
import CategoryTitle from './CategoryTitle';
export default (props) => {
  const {dataList,title,onMore} = props;

  return(
    <div>
      <CategoryTitle title={title} onMore={()=> {
        onMore && onMore();
      }}/>

      <div className={styles.vertical_box}>

        {dataList.map((item,i) =>(
          <div key={''+i} className={styles.vertical_item} onClick={()=>{
            history.push('/program/programDetail?programId=' + item.columnId + '&videoId=' + item.id + '&title=' + item.column.name);

          }}>
            <img src={item.image}/>

            <div>
              <label className={styles.vertical_title}>{item.videoName}</label>
              <label className={styles.vertical_sub}>{item.dateName}</label>
            </div>
          </div>
        ))}

      </div>
    </div>
  )

}
